"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hmsStore = exports.hmsStats = exports.hmsNotifications = exports.hmsActions = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var hms = new _reactSdk.HMSReactiveStore();
var hmsStore = hms.getStore();
exports.hmsStore = hmsStore;
var hmsActions = hms.getActions();
exports.hmsActions = hmsActions;
var hmsNotifications = hms.getNotifications();
exports.hmsNotifications = hmsNotifications;
var hmsStats = hms.getStats();
exports.hmsStats = hmsStats;